<template>
  <div style="display: inline-block">
    <v-btn v-if="getPackageConfig().chatGpt" color="primary" @click="openModal" outline>
      {{ $t('chatgpt_recommend') }}
    </v-btn>
    <v-btn color="grey lighten" v-else outline>
      {{ $t('chatgpt_recommend') }}
      <v-premium-lock2
        :inline="true"
        class="ml-2"
        :value="true"
        type="advanced"
        text="Upgrade to Advanced, starting at 990 baht / month to use this function"
      ></v-premium-lock2>
    </v-btn>
    <v-dialog v-model="showTransfer" scrollable max-width="1000px">
      <v-card>
        <v-premium-plan-popup
          text="You don't have to create your conversations anymore. Includes popular questions. One click can create conversation. Starting at 500 baht/month. Upgrade now!"
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium'"
        ></v-premium-plan-popup>
        <div class="text-xs-right">
          <v-btn icon>
            <v-icon @click="showTransfer = false">close</v-icon>
          </v-btn>
        </div>

        <v-card-text style="height: 800px;">
          <div class="form-control" style="display: flex; align-items: center;">
            <div style="width: 100%">
              <label> {{ $t('keyword_search_gpt') }}</label>
              <input
                type="text"
                v-model="search"
                :placeholder="$t('ex_price')"
                :disabled="loading"
                @keyup.enter="$refs.searchbtn.$el.click()"
                small
              />
            </div>
            <v-btn
              :disabled="search.length == 0 || loading"
              ref="searchbtn"
              depressed
              color="primary"
              @click="onSearchGptChat('search')"
              >{{ $t('Search') }}
              <v-icon small class="ml-1">search</v-icon>
            </v-btn>
          </div>

          <div class="pa-4" style="background: rgba(217, 217, 217, 0.2);">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <h3>{{ usertags.length }} {{ $t('results') }}</h3>
                <small class="mb-3">{{ $t('select_sentences_to_add') }}</small>
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-right">
                <v-btn
                  :disabled="search.length == 0"
                  ref="searchbtn"
                  depressed
                  flat
                  color="primary"
                  @click="onSearchGptChat('more')"
                  :loading="loading"
                >
                  <v-icon small class="mr-1">add</v-icon> {{ $t('more_result') }}
                </v-btn>
              </v-flex>
            </v-layout>

            <v-divider class="my-2"></v-divider>
            <div style="height: 200px; display: inline-block;">
              <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
                <tags
                  v-model="usertag"
                  :tags="usertags"
                  @tags-changed="addUserTags"
                  @before-adding-tag="checkUserTags"
                  :itemOption="tagOptions"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add')"
                ></tags>
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 200 alphabets')
                  }}</template>
                  <template v-else-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Tag')
                  }}</template>
                </span>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <h4>{{ $t('Conversation') }}</h4>
          </div>
          <div class="mt-3">
            <v-btn
              :disabled="loading"
              v-if="intentSelect.intentname"
              outline
              color="primary"
              small
              @click="
                showModal = true
                errorIntentRequire = false
              "
              >{{ $t('intent_selected') }} {{ intentSelect.intentname }}</v-btn
            >
            <v-btn
              :disabled="loading"
              v-else
              color="primary"
              small
              @click="
                showModal = true
                errorIntentRequire = false
              "
              errorIntentRequire="false"
              >{{ $t('select_create_conversation') }}</v-btn
            >
          </div>
        </v-card-text>
        <div class="text-xs-center" style="display: contents;">
          <small style="color:red" v-if="errorIntentRequire"
            >{{ $t('the_conversation_field_is_required') }}
          </small>
          <small style="color:red" v-if="errorSentenceRequire"
            >{{ $t('the_sentence_field_is_required') }}
          </small>
        </div>
        <div class="text-xs-center">
          <v-btn color="grey" outline @click="showTransfer = false" :disabled="loading">
            {{ $t('Back') }}
          </v-btn>
          <v-btn color="primary" depressed @click="submit" :loading="loading">
            {{ $t('Save') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="showModal" persistent max-width="1000">
      <chat-gpt-select-intent
        v-if="showModal"
        v-model="intentSelect"
        :showModal.sync="showModal"
      ></chat-gpt-select-intent>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Tags from '@/components/elements/Tags'
import Multiselect from 'vue-multiselect'
import ChatGptSelectIntent from './ChatGptSelectIntent.vue'
import api from '@/api'
export default {
  props: ['type', 'intents'],
  data: () => {
    return {
      errorIntentRequire: false,
      errorSentenceRequire: false,
      qvalData: '',
      usertag: '',
      errorTag: [],
      labelAddConversation: '',
      intentSelect: { intentname: '' },
      tagOptions: [],
      tagGptResult: [],
      search: '',
      showTransfer: false,
      currentPage: null,
      loading: true,
      showModal: false
    }
  },
  components: {
    Tags,
    Multiselect,
    ChatGptSelectIntent
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),

    usertags: {
      get() {
        const vm = this
        if (vm.qvalData && vm.qvalData !== '') {
          var usertags = []

          usertags = vm.qvalData.split(',')
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function(tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          return result
        } else {
          return []
        }
      },

      set(value) {
        const vm = this
        vm.errorSentenceRequire = false
        let result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }

        vm.qvalData = result.join(',')
        vm.tagGptResult = result
      }
    }
  },
  async mounted() {},
  methods: {
    async onSearchGptChat(type) {
      const vm = this
      vm.loading = true
      try {
        let response = await vm.post(`openai/${this.selectedBot.pageid}/gpt-suggest`, {
          keyword: vm.search
        })
        if (response.success) {
          if (response.result && response.result.choices && response.result.choices.length > 0) {
            if (type === 'search') {
              vm.tagGptResult = response.result.choices
            } else {
              vm.tagGptResult = vm.tagGptResult.concat(response.result.choices)
            }
            vm.tagGptResult = vm.tagGptResult.filter(
              (item, index) => vm.tagGptResult.indexOf(item) === index
            )
            vm.qvalData = vm.tagGptResult.join(',')
          }
        } else {
          if (response.result && response.result.error && response.result.error.message) {
            vm.$swal.fire({
              title: 'Load failed',
              title: response.result.error.message,
              type: 'error',
              confirmButtonText: vm.$t('Confirm')
            })
          }
        }

        vm.loading = false
      } catch (error) {
        vm.loading = false
        console.error(error)
      }
    },
    addTag(newTag) {
      const vm = this
      const tag = {
        intentname: newTag
      }
      vm.intents.push(tag)
      vm.intentSelect = tag
    },
    addUserTags(newTags) {
      const vm = this
      vm.usertags = newTags
    },
    setValueConversation(newTags) {
      const vm = this
      vm.labelAddConversation = newTags
    },
    checkUserTags(obj) {
      const vm = this
      vm.errorTag = []
      if (obj.tag.text.length > 200) {
        vm.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        vm.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    openModal: function() {
      const vm = this
      vm.qvalData = ''
      vm.intentSelect = { intentname: '' }
      vm.search = ''
      vm.showTransfer = true
      if (vm.currentPage) {
        vm.loading = true
      } else {
        vm.loading = false
      }
    },
    async editIntent() {
      const vm = this
      vm.loading = true
      let intent = {
        ...vm.intentSelect,
        pageid: vm.selectedBot.pageid,
        a_type: 'json',
        isShow: true,
        q_val: vm.intentSelect.q_val + ',' + vm.qvalData
      }
      intent['id'] = vm.intentSelect.id

      try {
        let response = await vm.put(`intents?id=${intent.id}`, intent)
        if (response.result === 'DUPLICATE_INTENT_NAME') {
          vm.$swal({
            title: vm.$t('Error'),
            type: 'error',
            text: vm.$t('duplicate_conversation_name'),
            confirmButtonText: vm.$t('Confirm')
          })
        }
        vm.loading = false
        if (response.responsecode === 200) {
          const swal = await vm.$swal.fire({
            title: `${vm.$t('conversation')} " ${intent.intentname.replace(/\<|\>/g, '')} " ${vm.$t(
              'edited'
            )}`,
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          if (swal.value) {
            vm.$emit('goto', intent.id)
          }
        }
      } catch (error) {
        console.error(error)
        vm.loading = false
      }
    },

    async submit() {
      const vm = this
      if (vm.intentSelect.intentname === '') {
        vm.errorIntentRequire = true
      }
      if (vm.qvalData === '') {
        vm.errorSentenceRequire = true
      }
      if (vm.intentSelect.intentname !== '' && vm.qvalData !== '') {
        if (vm.intentSelect.id) {
          vm.editIntent()
        } else {
          let intent = {
            intentname: vm.intentSelect.intentname || '',
            q_type: 'text',
            a_type: 'json',
            q_val: vm.qvalData,
            a_val: '[[]]',
            context_in: '',
            context_out: '',
            postidlist: '',
            userstatus: '',
            usertags: '',
            isShow: true,
            linenoti_status: false,
            linenoti_spec_ids: null,
            linenoti_text: null,
            starttime: null,
            endtime: null,
            intentstatus: true
          }

          intent.pageid = vm.selectedBot.pageid.toString()
          const swal = await vm.$swal.fire({
            title: vm
              .$t(`คุณต้องการเพิ่มบทสนทนาหัวข้อ ${intent.intentname} สำหรับเพจของคุณ`)
              .replace(/<|>/g, ''),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          if (swal.value) {
            vm.loading = true
            try {
              let response = await vm.post(`intents`, intent)
              if (response.result === 'DUPLICATE_INTENT_NAME') {
                vm.$swal({
                  title: vm.$t('Error'),
                  type: 'error',
                  text: vm.$t('duplicate_conversation_name'),
                  confirmButtonText: vm.$t('Confirm')
                })
              }
              vm.loading = false
              intent.id = response.id.toString()
              vm.$store.commit('SET_INTENT', intent)
              vm.showTransfer = false
              const swal = await vm.$swal.fire({
                title: `${vm.$t('conversation')} " ${intent.intentname.replace(
                  /\<|\>/g,
                  ''
                )} " ${vm.$t('added')}`,
                type: 'success',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })

              if (swal.value) {
                vm.$emit('goto', intent.id)
              }
              vm.$nextTick(() => {
                vm.loading = false
              })
            } catch (error) {
              console.error(error)
              vm.loading = false
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  background-color: aliceblue;
  padding: 10px;
  border-radius: 50%;
}
.chip {
  float: right;
  bottom: 12px;
  color: darkgray;
  pointer-events: none;
  background: #f0f0f0;
}
.btn-select {
  float: right;
  margin-top: -13px;
}
.small {
  position: absolute;
  padding: 0px 4px;
  color: palevioletred;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/ChatGptRecommend.vue